<template>
  <check-base-layout :pagetitle="pagetitle" :check-info-data="checkFrom">
    <template>
      <div>
        <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
      </div>
      <check-module :title="`账户信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">账户名称：{{checkFrom.receiptName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">开户行：{{checkFrom.receiptOpenBank}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">银行账号：{{checkFrom.receiptBankNumber}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div>银行行号：{{checkFrom.receiptOpenNumber}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`提现信息`">
        <template>
          <div style="background-color: #F5F7FA;padding:10px 20px;margin-bottom: 20px;">
            申请提现金额：
            <span style="color: #D35E5E">{{checkFrom.amount | toFixed}}</span>
          </div>
          <el-row>
            <el-col :span="12">
              <div style="padding:0 0 10px 20px;">付款方式：{{payMethodState[checkFrom.payMethod]}}</div>
            </el-col>
            <el-col :span="12">
              <div style="padding:0 0 10px 20px;">提现金额：{{checkFrom.amount | toFixed}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'
import { payMethodState } from '@/meun/date'

export default {
  name: 'customerdepositCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '客户提现审批'
    }
  },
  data () {
    return { payMethodState }
  },
  created () {
    this.getCustomerdepositCheckInfo()
  },
  methods: {
    getCustomerdepositCheckInfo () {
      const { snaId } = this
      checkApi.getCustomerdepositCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = deepClone(res.data.obj)
          this.$emit('update:data', deepClone(res.data.obj))
        }
      })
    }
  }
}
</script>
